const aiGeneratorDanish = {
  header: {
    title: "AI Opslag Generator",
    description: "Lad AI'en hjælpe dig med at skabe engagerende LinkedIn opslag baseret på dine præferencer"
  },
  customerBanner: {
    working: "Du genererer nu opslag for"
  },
  loading: {
    posts: "Henter dine nyeste AI-genererede opslag..."
  },
  noPosts: {
    title: "Ingen opslag fundet",
    description: "Dit system genererer automatisk nye LinkedIn opslag til dig hver uge. Når AI'en genererer dine opslag, vil de dukke op her, hvor du kan redigere og planlægge dem.",
    settings: "Hvis du ikke vil vente, kan du gå til",
    settingsLink: "Indstillinger",
    settingsAfter: "for at ændre dine præferencer."
  },
  post: {
    author: "LinkedIn Bruger",
    time: "Nu •",
    editHint: "Tryk Ctrl+Enter for at gemme, Esc for at annullere"
  },
  stats: {
    likes: "0",
    comments: "0",
    shares: "0"
  },
  aiPrompt: {
    placeholder: "Beskriv hvordan opslaget skal forbedres...",
    editing: "Redigerer",
    send: "Send"
  },
  buttons: {
    retry: "Prøv igen",
    generating: "Genererer",
    removeImage: "Fjern billede",
    nextImage: "Næste",
    addImage: "Billede",
    accept: "Accepter",
    scheduling: "Planlægger...",
    calculatingTimes: "Beregner tidspunkter...",
    noAvailableTimes: "Ingen ledige tidspunkter"
  },
  gallery: {
    title: "Vælg et billede",
    noImages: "Du har ingen billeder i dit arkiv.",
    goToArchive: "Gå til billedearkiv"
  },
  imageOptions: {
    title: "Tilføj billede",
    gallery: "Vælg fra billedearkiv",
    upload: "Upload nyt billede",
    camera: "Tag billede",
    manage: "Administrer billedearkiv"
  },
  messages: {
    imageUpdated: "Billede opdateret!",
    imageRemoved: "Billede fjernet!",
    savedChanges: "Ændringer gemt!",
    regenerated: "Opslaget er blevet regenereret!",
    updated: "Opslaget er blevet opdateret!",
    newPost: "Nyt opslag oprettet!",
    accepted: "Dit opslag er blevet accepteret og flyttet til \"Mine Opslag\", hvor du kan planlægge det til deling på LinkedIn!",
    calculatingTimes: "Beregner ledige tidspunkter...",
    noScheduledTimes: "Der er ingen planlagte tidspunkter sat i din scheduler. Gå til Scheduler for at sætte tidspunkter op.",
    postScheduled: "Opslag planlagt til {formattedDate}",
    imageUploaded: "Billede uploadet og tilføjet til dit opslag!",
    error: "Der opstod en fejl. Prøv igen senere."
  }
};

export default aiGeneratorDanish; 